let interval_id = null;
let fetch_count = 0;

export default function () {
    interval_id = window.setInterval(fetch, 8000);
}

function update_value(value) {
    if (value < 1) {
        return;
    }
    if (is_value_unchanged(value)) {
        return;
    }

    const $container = $(".item_view_attributes__current_viewers");
    if ($container.is(":hidden")) {
        $container.removeClass("item_view_attributes__current_viewers--hidden");
    }

    $container.addClass("flash_text");
    window.setTimeout(
        function() {
            $(".item_view_attributes__current_viewers_value_count").text(value);
        },
        400
    );
    window.setTimeout(
        function() {
            $container.removeClass("flash_text");
        },
        1100
    );
}
function is_value_unchanged(compare) {
    const value = $(".item_view_attributes__current_viewers_value_count").text();

    if (value === '') {
        return true;
    }

    return parseInt(value) === parseInt(compare);
}

function fetch () {
    if (fetch_count > 10) {
        if (null !== interval_id) {
            window.clearInterval(interval_id);
            interval_id = null;
        }
        return;
    }

    fetch_count++;
    $.getJSON(
        mtbn.bikemarkt.urls.current_item_viewers,
        {
            id: mtbn.bikemarkt.item_id
        },
        function (data) {
            update_value(data.data);
        }
    );
}
